import { IconColor, IconType } from '@/types';

export const ICON_COLOR = IconColor.COLOR;
export const ICON_SOCIALS_COLOR = IconColor.GRAY;
export const ICON_SOCIALS_TYPE = IconType.DEFAULT;
export const ICON_INSTITUTION_COLOR = IconColor.COLOR;
export const ICON_PLATFORM_COLOR = IconColor.GRAY;
export const ICON_PROJECT_DETAIL_FUNCTION_COLOR = IconColor.WHITE;
export const ICON_PROJECT_DETAIL_USED_COLOR = IconColor.WHITE;